module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-basket-details"
  }, [_c('div', {
    staticClass: "order-basket-details-bloc"
  }, [_c('header', {
    staticClass: "order-basket-details-list"
  }, [_c('div', [_c('div', {
    staticClass: "basket-title"
  }, [_c('span', {
    staticClass: "arrow pointer",
    on: {
      "click": function($event) {
        _vm.toggleBasket();
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOpen),
      expression: "!isOpen"
    }]
  }, [_c('i', {
    staticClass: "fas fa-angle-down"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  }, [_c('i', {
    staticClass: "fas fa-angle-up"
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "basketName"
  }, [_vm._v("\n                        " + _vm._s(_vm.basket.name) + " "), _c('span', {
    staticClass: "countItems"
  }, [_vm._v("(" + _vm._s(_vm.basket.nbItems) + " " + _vm._s(_vm.$t("orders.tableOrder.items")) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "basket-subTotal txtRight"
  }, [_c('span', {
    staticClass: "subTotal"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelSubTotal")) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "subTotal-price"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("CurrencyCustomPipe")(_vm.displayRealPrice(_vm.basket.finalPrice, _vm.order.priceShown), "en-US", _vm.basket.currency.shortName)))])])])]), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "basketContent"
  }, _vm._l((_vm.basket.orderItems), function(item) {
    return _c('div', {
      key: item.id
    }, [_c('OrderBasketItem', {
      attrs: {
        "item": item,
        "currency": _vm.basket.currency
      }
    })], 1)
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb2155b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMain/orderBasketDetails.vue
// module id = 3363
// module chunks = 0